'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('./index-fccd5f88.js');
var injectGlobalCss = require('./injectGlobalCss-bc8cf911.js');
var Typography = require('./Typography-8468e4cf.js');
var Button = require('./Button-ef2d53dd.js');
var Titles = require('./Titles-870a0750.js');
require('./Icons-46f5553f.js');
require('./Loader-ba47a627.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css = ".Banner_module_visuallyHidden__4aa18c6c {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.Banner_module_youtubeVideo__4aa18c6c {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}\n\n.Banner_module_Banner__4aa18c6c {\n  position: relative;\n  width: 100%;\n  background-color: #ffffff;\n  border-radius: 14px;\n  border: 1px solid #444f6b;\n  padding: 14px;\n  z-index: 1;\n  margin-bottom: 24px;\n  transition: all 0.4s ease;\n}\n.Banner_module_Banner__4aa18c6c svg {\n  position: relative !important;\n  left: 0 !important;\n  bottom: auto !important;\n  height: auto !important;\n}\n\n.Banner_module_Title__4aa18c6c {\n  padding-right: 44px;\n}\n\n.Banner_module_Paragraph__4aa18c6c {\n  padding-left: 36px;\n  padding-right: 44px;\n}\n\n.Banner_module_Close__4aa18c6c {\n  position: absolute;\n  right: 0;\n  top: 0;\n  padding: 2px 0 !important;\n}\n\n.Banner_module_Show__4aa18c6c {\n  visibility: visible;\n  opacity: 1;\n  transform: translate(0, 0);\n}\n\n.Banner_module_Hide__4aa18c6c {\n  visibility: hidden;\n  pointer-events: none;\n  opacity: 0;\n  transform: translate(0, -25%);\n}";
injectGlobalCss.injectCss(css, "/opt/atlassian/pipelines/agent/build/src/stories/components/Organisms/Banner/Banner.module.scss");
var modules_22e079fa = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"Banner_module_visuallyHidden__4aa18c6c","youtubeVideo":"Banner_module_youtubeVideo__4aa18c6c","Banner":"Banner_module_Banner__4aa18c6c","Title":"Banner_module_Title__4aa18c6c","Paragraph":"Banner_module_Paragraph__4aa18c6c","Close":"Banner_module_Close__4aa18c6c","Show":"Banner_module_Show__4aa18c6c","Hide":"Banner_module_Hide__4aa18c6c"};

function Banner(_ref) {
  var extraClass = _ref.extraClass,
    iconName = _ref.iconName,
    iconColor = _ref.iconColor,
    color = _ref.color,
    title = _ref.title,
    message = _ref.message,
    backgroundColor = _ref.backgroundColor,
    borderColor = _ref.borderColor,
    showBanner = _ref.showBanner,
    closeAction = _ref.closeAction,
    showCloseButton = _ref.showCloseButton;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_22e079fa.Banner, extraClass, showBanner ? modules_22e079fa.Show : modules_22e079fa.Hide].join(" "),
    style: {
      backgroundColor: backgroundColor,
      borderColor: borderColor
    }
  }, /*#__PURE__*/React__default["default"].createElement(Titles.Title, {
    iconName: iconName,
    iconColor: iconColor,
    color: color,
    titleSize: "BASE",
    bold: true,
    extraClass: modules_22e079fa.Title
  }, title), /*#__PURE__*/React__default["default"].createElement(Typography.Paragraph, {
    color: color,
    extraClass: modules_22e079fa.Paragraph
  }, message), showCloseButton ? /*#__PURE__*/React__default["default"].createElement(Button.Button, {
    action: closeAction,
    extraClass: modules_22e079fa.Close,
    style: "PLAIN",
    iconColor: iconColor,
    icon: "ICON",
    iconName: "ui-close",
    label: "close"
  }) : null);
}
Banner.propTypes = {
  extraClass: index.propTypes.exports.string,
  title: index.propTypes.exports.string,
  message: index.propTypes.exports.string,
  color: index.propTypes.exports.string,
  iconName: index.propTypes.exports.string,
  iconColor: index.propTypes.exports.string,
  backgroundColor: index.propTypes.exports.string,
  borderColor: index.propTypes.exports.string,
  showBanner: index.propTypes.exports.bool,
  closeAction: index.propTypes.exports.func,
  showCloseButton: index.propTypes.exports.bool
};

exports.Banner = Banner;
